// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IAuditActor } from './IAuditActor';
import {
    IAuditActorFromJSON,
    IAuditActorFromJSONTyped,
    IAuditActorToJSON,
    IAuditActorToJSONTyped,
} from './IAuditActor';

/**
 * 
 * @export
 * @interface IAccountStatusDto
 */
export interface IAccountStatusDto {
    /**
     * 
     * @type {number}
     * @memberof IAccountStatusDto
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof IAccountStatusDto
     */
    account_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IAccountStatusDto
     */
    status?: IAccountStatusDtoStatusEnum;
    /**
     * 
     * @type {Date}
     * @memberof IAccountStatusDto
     */
    valid_from?: Date;
    /**
     * 
     * @type {Date}
     * @memberof IAccountStatusDto
     */
    valid_to?: Date;
    /**
     * 
     * @type {IAuditActor}
     * @memberof IAccountStatusDto
     */
    audit_actor?: IAuditActor;
    /**
     * 
     * @type {string}
     * @memberof IAccountStatusDto
     */
    update_source?: IAccountStatusDtoUpdateSourceEnum;
}

/**
* @export
* @enum {string}
*/
export enum IAccountStatusDtoStatusEnum {
    OPEN = 'OPEN',
    CLOSED = 'CLOSED',
    PENDING_CLOSED = 'PENDING_CLOSED',
    FROZEN = 'FROZEN',
    PENDING = 'PENDING'
}
/**
* @export
* @enum {string}
*/
export enum IAccountStatusDtoUpdateSourceEnum {
    FILE = 'FILE',
    API = 'API',
    ADMIN_PORTAL = 'ADMIN_PORTAL',
    USER_PORTAL = 'USER_PORTAL'
}


/**
 * Check if a given object implements the IAccountStatusDto interface.
 */
export function instanceOfIAccountStatusDto(value: object): value is IAccountStatusDto {
    return true;
}

export function IAccountStatusDtoFromJSON(json: any): IAccountStatusDto {
    return IAccountStatusDtoFromJSONTyped(json, false);
}

export function IAccountStatusDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IAccountStatusDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'account_id': json['account_id'] == null ? undefined : json['account_id'],
        'status': json['status'] == null ? undefined : json['status'],
        'valid_from': json['valid_from'] == null ? undefined : (new Date(json['valid_from'])),
        'valid_to': json['valid_to'] == null ? undefined : (new Date(json['valid_to'])),
        'audit_actor': json['audit_actor'] == null ? undefined : IAuditActorFromJSON(json['audit_actor']),
        'update_source': json['update_source'] == null ? undefined : json['update_source'],
    };
}

export function IAccountStatusDtoToJSON(json: any): IAccountStatusDto {
    return IAccountStatusDtoToJSONTyped(json, false);
}

export function IAccountStatusDtoToJSONTyped(value?: IAccountStatusDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'account_id': value['account_id'],
        'status': value['status'],
        'valid_from': value['valid_from'] == null ? undefined : ((value['valid_from']).toISOString()),
        'valid_to': value['valid_to'] == null ? undefined : ((value['valid_to']).toISOString()),
        'audit_actor': IAuditActorToJSON(value['audit_actor']),
        'update_source': value['update_source'],
    };
}

